import { Column, Editing, Item, Toolbar } from 'devextreme-react/data-grid';
import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { Card, Button as RxButton } from 'reactstrap';
import Breadcrumb from '../../../components/common/breadcrumb';
import DatagridCustom from '../../../components/common/datagrid/custom-datagrid';
import api from '../../../services/api-configuration';
import useFormatMessage from '../../../utils/useFormatMessage';

export const SevkBolgeleri = () => {
    const { t } = useFormatMessage();
    const [dataSources, setDataSources] = useState([]);
    const ref = useRef();

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await api.post("/shippingRegion/getAll");
            setDataSources(response.data.data || []);
        } catch (error) {
            console.error("Error fetching regions:", error);
            toast.error(t("Veri yüklenirken hata oluştu"));
        }
    };

    const handleServerOperation = async (operationType, data, e) => {
        try {
            const employeeId = parseInt(
                Buffer.from(localStorage.getItem("employee_id"), 'base64').toString('ascii')
            );

            const payload = {
                ...data,
                ...(operationType === 'create' ? {
                    create_user_id: employeeId,
                    code: ""
                } : {
                    update_user_id: employeeId
                })
            };

            const endpoint = operationType === 'create'
                ? "shippingRegion/create"
                : "shippingRegion/update";

            const response = await api.post(endpoint, payload);

            if (response.status === 200) {
                // Sunucudan gelen güncel veriyi kullanarak state'i güncelleyin
                const updatedData = response.data.data || payload;

                setDataSources(prevData =>
                    operationType === 'create'
                        ? [...prevData, updatedData]
                        : prevData.map(item =>
                            item.id === updatedData.id ? updatedData : item
                        )
                );

                e.component.saveEditData();
                toast.success(
                    operationType === 'create'
                        ? t("Ekleme başarılı")
                        : t("Güncelleme başarılı")
                );

                return true;
            }
        } catch (error) {
            console.error(`Error in ${operationType}:`, error);
            const errorMessage = error.response?.data?.error || t("Hata oluştu");
            toast.error(errorMessage);
            return false;
        } finally {
            fetchData();
        }
    };

    const onRowValidating = (e) => {
        if (e.brokenRules.length === 0) {
            const operationType = e.oldData ? 'update' : 'create';
            const data = operationType === 'create'
                ? e.newData
                : { ...e.oldData, ...e.newData };

            // Doğrudan handleServerOperation'ı çağırın
            handleServerOperation(operationType, data, e);
        }
    };

    return (
        <>
            <Breadcrumb current={t("Sevk Bölge Tanımları")} />
            <Card className="p-4">
                <DatagridCustom
                    dataSource={dataSources}
                    reff={ref}
                    key={"id"}
                    keyExpr={"id"}
                    onRowValidating={onRowValidating}
                    onInitNewRow={(e) => {
                        e.data.is_active = true;
                        e.component.__addingStart = true;
                    }}
                >
                    <Editing
                        mode="popup"
                        popup={{
                            title: t("Yeni Sevk Bölgesi"),
                            showTitle: true,
                            width: 600,
                            height: 400,
                        }}
                        allowUpdating
                        allowAdding
                        useIcons
                    />
                    <Column dataField="code" caption={t("Bölge Kodu")} alignment='center' selectedFilterOperation='contains' />
                    <Column dataField="name" caption={t("Bölge Adı")} alignment='center' selectedFilterOperation='contains' />
                    <Column dataField="grupaj_time" caption={t("Grupaj Süresi (Gün)")} visible={false} dataType='number' alignment='center' selectedFilterOperation='contains' />
                    <Column dataField="shipping_time" caption={t("Sevkiyat Süresi (Gün)")} visible={false} dataType='number' alignment='center' selectedFilterOperation='contains' />
                    <Column dataField="average_km" caption={t("Ortalama KM")} visible={false} dataType='number' alignment='center' selectedFilterOperation='contains' />
                    <Column dataField="is_active" caption={t("Aktif")} dataType="boolean" alignment='center' selectedFilterOperation='contains' />

                    <Toolbar>
                        <Item name="addRowButton" />
                        <Item name="exportButton" />
                        <Item location="after">
                            <RxButton
                                color="light"
                                outline
                                onClick={fetchData}
                                style={{
                                    border: "1px solid #c8ced3",
                                    paddingInline: "10px",

                                }}
                            >
                                <i className="fa fa-refresh"></i>
                            </RxButton>
                        </Item>
                    </Toolbar>
                </DatagridCustom>
            </Card>
        </>
    );
};